// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eae27af9","455":"39fb8d3a","977":"08e911c6"}[chunkId] + ".chunk.js";
};